export default __webpack_public_path__ + "assets/images/36ee566873e35832c0c588ef7063881d.jpg";